import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

export const EmptyState = () => {
  return (
    <Box
      paddingX="s24"
      alignItems="center"
      gap="s12"
      paddingTop="s48"
      data-testid="log-empty-state"
    >
      <Icon.Large icon="history" color="grey700" />

      <Text.Normal color="grey700" size="200">
        {i18n.t('activity_log.empty_state')}
      </Text.Normal>
    </Box>
  )
}
